import { MultiSelect } from "primereact/multiselect";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDropzone } from "react-dropzone";
import { IoArrowBackOutline } from "react-icons/io5";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import { useLocation, useNavigate } from "react-router-dom";
import InputField from "../../components/ui/Input";
import QuillToolbar, { formats, modules } from "../../components/ui/QuillToolbar";
import { ErrorMessages } from "../../constants/Labels";
import { getLoginUserID } from "../../services/AuthService";
import { deleteTipFile, getTipDetailsByID, saveTip, UpdateTip } from "../../services/ContributeService";
import { getLookUPData } from "../../services/ResourcesService";
import { showToastError, showToastSuccess } from "../../utils/common/ToastMessages";
import { isNotEmptyString, notAllowSpaces } from "../../utils/common/Validation";


interface UserTypes {
    TypeId: number;
    UserType: string;
}
interface AgeRange {
    AgeId: number;
    AgeRange: string;
    AgeRangeDisplayName: string;
}

export default function EditContributeTip() {
    let userDetails = getLoginUserID();
    const navigate = useNavigate()
    const urlPattern = /^(https?:\/\/)?((([a-zA-Z\d]([a-zA-Z\d-]*[a-zA-Z\d])*)\.)+[a-zA-Z]{2,}|((\d{1,3}\.){3}\d{1,3}))(:\d+)?(\/[-a-zA-Z\d%_.~+&=]*)*(\?[;&a-zA-Z\d%_.~+=-]*)?(#[-a-zA-Z\d_]*)?$/i; //working uat url resource, community, contribute
    const validImageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp'];

    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [webLink, setWebLink] = useState("");
    const [isSensitive, setIsSensitive] = useState(false);
    const [selectedItems, setSelectedItems] = useState<any>([]);
    const [selectedTagItems, setselectedTagItems] = useState<any>([]);
    const [files, setFiles] = useState<File[]>([]);
    const [newFiles, setNewFiles] = useState<File[]>([]); // Newly added files
    const [tipIdsToDelete, setTipIdsToDelete] = useState<any>([]);
    const [errors, setErrors] = useState<{ [key: string]: string }>({});
    const [selectedItem, setSelectedItem] = useState<any>()
    const [Topicoptions, setTopicoptions] = useState<any>([]);
    const [Tagptions, setTagptions] = useState<any>([]);
    const [inputValue, setInputValue] = useState("");
    const [inputTagValue, setInputTagValue] = useState("");
    const [userTypes, setUserTypes] = useState<UserTypes[]>([]);
    const [ageRange, setAgeRange] = useState<AgeRange[]>([]);

    
    const selectedItemsTooltip = useRef(null);
    const location = useLocation()
    const selectedTipId = location.state
    console.log(selectedTipId, "selectedtipid")

    // To get the lookup data  
    const lookupdata = () => {
        getLookUPData().then((response: any) => {
            // Filter tags to show only specified values
            const allowedTags = [
                "Resource for 0-4 years old",
                "Resource for 5-10 years old",
                "Resource for 11-17 years old",
                "Resource for 18-24 years old",
                "Resource for 25-64 years old",
                "Resource for 65+ years old"
            ];
            const filteredTags = (response[0]?.Tags || []).filter((tag: any) =>
                allowedTags.includes(tag.TagName)
            );
            setTagptions(filteredTags);
            setTopicoptions(response[0]?.Topics);
            setUserTypes(response[0]?.UserTypes);
            setAgeRange(response[0]?.AgeRange);
            console.log(filteredTags, "filtered tags")
        })
            .catch(() => {
                showToastError("Error while getting lookup data");
            });
    };
    // To view Tip details
    const viewTipDetails = async () => {
        try {
            const response: any = await getTipDetailsByID(selectedTipId);
            setSelectedItem(response?.tipDetails[0]);
        } catch (error) {
            showToastError(ErrorMessages.SomethingWrong);
        }
    };
    // TO call lookup data & tipdetials on load
    useEffect(() => {
        lookupdata();
        if ((selectedTipId !== undefined || selectedTipId != 0) && (selectedTipId != 'New')) {
            viewTipDetails();
        }
    }, [selectedTipId]);

    // In edit mode to bind values to the form
    useEffect(() => {
        if (selectedItem && Object.keys(selectedItem).length > 0) {
            setTitle(selectedItem.title);
            setDescription(selectedItem.description);
            setWebLink(selectedItem.link);
            setIsSensitive(selectedItem?.isSensitive)

            const selectedTopics = Array.isArray(selectedItem?.topicNames) ? selectedItem?.topicNames : [];
            setSelectedItems(selectedTopics);
              const keyMapping: { [key: string]: string } = {
                "Autistic Individual": "Autisticindividuals",
                "Family member or Friend": "Familymembers",
                "Researcher": "Researchers",
                "Care Professional": "Professionals",
                "Prefer not to say": "Prefernottosay",
                "Other Professional": "Otherprofessional"
            };

            // Initialize `checkedUserTypes` using `keyMapping`
            const initialCheckedUserTypes: { [key: string]: boolean } = {};

            if (selectedItem.UserTypes && selectedItem.UserTypes[0]) {
                const backendUserTypes = selectedItem.UserTypes[0]; // Extract the first object

                Object.entries(backendUserTypes).forEach(([backendKey, value]) => {
                    const frontendKey = Object.keys(keyMapping).find(
                        (key) => keyMapping[key] === backendKey
                    );
                    if (frontendKey) {
                        initialCheckedUserTypes[frontendKey] = value === true;
                    }
                });
            }
            setcheckedUserTypes(initialCheckedUserTypes);
            if (selectedItem?.ageGroups) {
    // Build object: {1: true, 3: true}
    const initialChecked: Record<number, boolean> = {};
    selectedItem.ageGroups.forEach((age: any) => {
      initialChecked[age.AgeID] = true;
    });

    setCheckedAgeRanges(initialChecked);
  }
            const selectedTags = Array.isArray(selectedItem?.tagNames) ? selectedItem?.tagNames : [];
            setselectedTagItems(selectedTags);
            if (selectedItem.media) {
                const files = selectedItem.media.map((mediaItem: any) => ({
                    name: mediaItem.FileName,
                    Id: mediaItem.TipMediaID
                }));
                setFiles(files);
                setNewFiles(files);
            } else {
                setFiles([]);
                setNewFiles([]);
            }
        }
    }, [selectedItem]);

    // Form handlechange function
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "",
        }));

        switch (name) {
            case "title":
                setTitle(value);
                break;
            case "webLink":
                setWebLink(value);
                break;

            default:
                break;
        }
    };
    const handleDescriptionChange = (
        value: string,
        delta: any,
        source: any,
        editor: any
    ) => {
        setDescription(value);
        setErrors((prevErrors) => ({
            ...prevErrors,
            description: "",
        }));
    };
    const handleCheckboxChange = () => {
        setIsSensitive(prevIsSensitive => !prevIsSensitive);
    };
    // convert tip form data into formdata payload
    const submitHandler = async (e: any) => {
        e.preventDefault();
        const tagNames = selectedTagItems?.map((item: any) => item.TagName).join(",");
        const topicNames = selectedItems?.map((item: any) => item.TopicName).join(",");
         const userTypeIds = Object.keys(checkedUserTypes).filter((key) => checkedUserTypes[key]).map((key) =>
            userTypes?.find(
                (type: any) => type.UserType === key
            )?.TypeId
        ).filter(Boolean);
        const userTypePayload = userTypes.reduce((acc: any[], userType: any) => {
            const keyMapping: { [key: string]: string } = {
                "Autistic Individual": "Autisticindividuals",
                "Family member or Friend": "Familymembers",
                "Researcher": "Researchers",
                "Care Professional": "Professionals",
                "Prefer not to say": "Prefernottosay",
                "Other Professional": "Otherprofessional"
            };

            const key = keyMapping[userType.UserType];
            const value = checkedUserTypes[userType.UserType] ? 1 : 0;

            // Add key-value pair to the appropriate group
            if (acc.length === 0) acc.push({}); // Ensure at least one object exists
            const lastGroup = acc[acc.length - 1];

            // Add the key-value pair to the current group
            lastGroup[key] = value;

            return acc;
        }, []);
    //    const ageRange =  checkedAgeRanges.join(",") || null
//     const ageRange = Object.keys(checkedAgeRanges)
//   .filter((id) => checkedAgeRanges[Number(id)]) // keep only checked
//   .join(",");
const ageRange = "";

       console.log(ageRange, "Selected AgeIds")
        const newErrors: { [key: string]: string } = {};
        if (!isNotEmptyString(title)) {
            newErrors.title = ErrorMessages.TitleRequired;
        }
        if (selectedItems.length === 0) {
            newErrors.topic = ErrorMessages.TopicsRequired;
        }
        if (isNotEmptyString(webLink) && !urlPattern.test(webLink)) {
            newErrors.webLink = "Please enter a valid URL";
        }
        setErrors(newErrors);
        // If there are no errors, creating payload
        if (Object.keys(newErrors).length === 0) {
            if (tipIdsToDelete.length > 0) {
                tipIdsToDelete.map((tipId: any) => {
                    let obj = {
                        "tipMediaLinkId": tipId
                    };
                    return deleteTipFile(obj).then((res: any) => {
                    })
                        .catch(error => {
                            showToastError("Failed to delete file but you can proceed with updating the Tip.");
                        });
                });
            }
            try {
                if (selectedTipId == 'New') {
                    const formData2 = new FormData();
                    formData2.append("Title", title);
                    formData2.append("Description", description);
                    formData2.append("Link", webLink);
                    formData2.append("TopicNames",topicNames);
                    formData2.append("IsSensitive", isSensitive.toString());
                    formData2.append("CreatedBy", userDetails?.userId);
                    formData2.append("TagNames", tagNames ? tagNames : []);
                    formData2.append("IsAdmin", "1");
                    formData2.append("AgeGroupID", ageRange);
                    formData2.append("UserTypes", JSON.stringify(userTypePayload));
                    
                    await SaveTipDetails(formData2);
                } else {
                    const formData = new FormData();
                    formData.append("Title", title);
                    formData.append("Description", description);
                    formData.append("Link", webLink);
                    formData.append("ReviewedBy", userDetails?.userId);
                    formData.append("TagNames", tagNames ? tagNames : []);
                    formData.append("TopicNames", topicNames);
                    formData.append("TipId", selectedItem?.tipId || 0);
                    formData.append("IsSensitive", isSensitive?.toString());
                    formData.append("AgeGroupID", ageRange);
                    formData.append("UserTypes", JSON.stringify(userTypePayload));
                    
                    const uniqueFromSecondArray = files.filter(item => !newFiles.includes(item));
                    if (files.length > 0) {
                        uniqueFromSecondArray.forEach((file: any) => {
                            formData.append("files", file);
                        });
                    } else {
                        formData.append("files", '');
                    }

                    await UpdateTipDeatils(formData);
                }
                navigate('/contribute');
            } catch (error) {
                showToastError('Error saving tip');
            }
        }
    };
    const SaveTipDetails = async (formData: any) => {
        try {
            const response  :any = await saveTip(formData); 
            if (response.status) {
                showToastSuccess(response.message);
                navigate('/contribute'); 
            } else {
                showToastError(response.message); 
            }
        } catch (error) {
            showToastError("An error occurred while updating Tip"); 
        }
    };
    const UpdateTipDeatils = (formData: any) => {
        UpdateTip(formData).then((response: any) => {
            if (response.status) {
                showToastSuccess(response.message);
                navigate('/contribute')
                return;
            }
            showToastError(response.message);
        })
            .catch(() => {
                showToastError("An error occurred while updating Tip");
            });
    };
    // TO avoid empty spaces cursor moving
    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        notAllowSpaces(event.currentTarget.value, event);
    };
    // Handlers for Tag and Topic changes
    const handleTagChanges = (e: any) => {
        const selectedTags = e.value.map((tagName: string) =>
            Tagptions?.find((tag: any) => tag?.TagName === tagName)
        );
        setselectedTagItems(selectedTags);
    };
    // Handle change to set selected topics
    const handleTopicChanges = (e: any) => {
        const selectedTopics = e.value.map((topicName: string) =>
            Topicoptions?.find((topic: any) => topic?.TopicName === topicName)
        );
        setSelectedItems(selectedTopics);
    };

    // To show newly added Topic
    const handleAddNewItem = (event: React.KeyboardEvent) => {
        if ((event.key === "Enter" || event.key === "Tab") && isNotEmptyString(inputValue)) {
            event.preventDefault(); // Prevent default behavior
            if (inputValue && !(Topicoptions ?? []).some((option: any) => option?.TopicName === inputValue)) {
                const newTopic = { TopicId: " ", TopicName: inputValue };
                setTopicoptions([...(Topicoptions ?? []), newTopic]);
                setSelectedItems([...selectedItems, newTopic]);
                setInputValue("");
            }
        }
    };
    // To show newly added tag
    const handleAddNewTag = (event: React.KeyboardEvent) => {
        if ((event.key === "Enter" || event.key === "Tab") && isNotEmptyString(inputTagValue)) {
            event.preventDefault(); // Prevent default behavior
            if (
                inputTagValue &&
                !(Tagptions ?? []).some((option: any) => option.TagName === inputTagValue)
            ) {
                const newTag = { TagId: " ", TagName: inputTagValue };
                setTagptions([...(Tagptions ?? []), newTag]);
                setselectedTagItems([...selectedTagItems, newTag]);
                setInputTagValue("");
            }
        }
    };

    const [checkedUserTypes, setcheckedUserTypes] = useState<any>([])
    const [checkedResourceTypes, setCheckedResourceTypes] = useState<any>([])

     const handleUserTypeChange = (event: any) => {
        const { name, checked } = event.target;
        setcheckedUserTypes((prevTopics: any) => ({
            ...prevTopics,
            [name]: checked,
        }));
    };

     const [checkedAgeRanges, setCheckedAgeRanges] = useState<any>([])

    //  const handleAgeRangeChange = (event: any) => {
    //     const { name, checked } = event.target;
    //     setcheckedAgeRanges((prevTopics: any) => ({
    //         ...prevTopics,
    //         [name]: checked,
    //     }));
    //     console.log(checkedAgeRanges, "agerange")
    // };
    // const [checkedAgeRanges, setCheckedAgeRanges] = useState<string[]>([]);

// const handleAgeRangeChange = (event: any) => {
//   const { value, checked } = event.target; // value = AgeId

//   setCheckedAgeRanges((prev:any) =>
//     checked ? [...prev, value] : prev.filter((id:any) => id !== value)
//   );
// };

const handleAgeRangeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  const { value, checked } = e.target;
  const ageId = Number(value); // value comes as string from input

  setCheckedAgeRanges((prev:any) => ({
    ...prev,       // copy old object (not iterable, but spreadable ✅)
    [ageId]: checked,
  }));
};


    // Template to add new topics
    const headerTemplate = () => {
        return (
            <div className="p-multiselect-header">
                <input
                    type="text"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    onKeyDown={handleAddNewItem}
                    placeholder="Type and press enter to add new topic"
                    className="p-multiselect-filter form-control"
                />
            </div>
        );
    };
    // Template to add new tags
    const headerTemplateTag = () => {
        return (
            <div className="p-multiselect-header">
                <input
                    type="text"
                    value={inputTagValue}
                    onChange={(e) => setInputTagValue(e.target.value)}
                    onKeyDown={handleAddNewTag}
                    placeholder="Type and press enter to add new tags"
                    className="p-multiselect-filter form-control"
                />
            </div>
        );
    };


    return (
        <div className="px-3">
            <div className="bg-white rounded shadow-sm p-3 h-calc-100vh-minus-103 overflow-y-auto">
                <div className="d-flex align-items-center mb-3">
                    <IoArrowBackOutline size={20} className="me-2  cursor-pointer" onClick={() => navigate('/contribute')} />
                    <h3 className="fw-bold my-0 pt-1">
                        {selectedTipId == 'New' ? 'Save Tip' : 'Update Tip'}</h3>
                </div>

                <form onSubmit={submitHandler}>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="position-relative mb-3 h-49">
                                <InputField
                                    name="title"
                                    label="Title"
                                    value={title}
                                    placeholder="Enter your Tip Title here "
                                    onChange={handleChange}
                                    error={errors.title}
                                    onKeyDown={handleKeyDown}
                                />
                            </div>
                            <div className="form-group position-relative mb-3 ">
                                <label className="form-group ">Add Topic</label>
                                <div className="smart-multiselect">
                                    <MultiSelect
                                        value={selectedItems?.map((item: any) => item?.TopicName)}
                                        options={Topicoptions?.map((option: any) => ({
                                            label: option?.TopicName,
                                            value: option?.TopicName,
                                        }))}
                                        onChange={handleTopicChanges}
                                        filter
                                        display="chip"
                                        panelHeaderTemplate={headerTemplate}
                                        style={{ width: "100%" }}
                                        placeholder="Select Topics"
                                        ref={selectedItemsTooltip}

                                    />

                                    {errors.topic && (
                                        <div className="error text-danger mt-5">{errors?.topic}</div>
                                    )}
                                </div>
                            </div>
                             <div className="form-group position-relative mb-3">
                                <label className="form-group ">Age Range</label>
                                <div className="smart-multiselect">
                                    <MultiSelect
                                        value={selectedTagItems?.map((item: any) => item?.TagName)}
                                        options={Tagptions?.map((option: any) => ({
                                            label: option?.TagName,
                                            value: option?.TagName,
                                        }))}
                                        onChange={handleTagChanges}
                                        filter
                                        display="chip"
                                        panelHeaderTemplate={headerTemplateTag}
                                        style={{ width: "100%" }}
                                        placeholder="Choose the age range(s) your tip is for"
                                        ref={selectedItemsTooltip}
                                    />
                                    {errors.tags && (
                                        <div className="error text-danger mt-1">{errors.tags}</div>
                                    )}
                                </div>
                            </div> 
                            <div className="position-relative mb-3">
                                <InputField
                                    name="webLink"
                                    label="Links"
                                    value={webLink}
                                    placeholder="Web link "
                                    onChange={handleChange}
                                    error={errors.webLink}
                                    onKeyDown={handleKeyDown}
                                />
                            </div>
                            <div className="position-relative mb-3">
                                <div className="d-flex justify-content-start align-items-center">


                                    <input
                                        type="checkbox"
                                        checked={isSensitive}
                                        onChange={handleCheckboxChange}
                                        className=" form-check-input mt-0 cursor-pointer !w-[18px] !h-[18px] form-check !p-[10px]"
                                    /> <span className="p-1 d-inline-block h-[24px] ms-1">Sensitive Content </span>
                                </div>
                            </div>        
                        </div>
                        <div className="col-md-6">
                            <div className="position-relative mb-0 ">
                                <div className="form-group position-relative mb-3 textarea-h-273">
                                    <QuillToolbar />
                                    <div className="" >
                                        <ReactQuill
                                            value={description}
                                            onChange={handleDescriptionChange}
                                            placeholder="Enter your Description here"
                                            modules={modules}
                                            formats={formats}
                                            onKeyDown={handleKeyDown}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
<div className="position-relative mb-2 mt-3 p-3 border rounded " >
                                <h4 className="d-flex justify-content-start fw-bold mb-0">
                                    {" "}
                                    User Types{" "}
                                </h4>
                                <div className="d-flex p-2 row">
                                    {userTypes?.map((topic: any) => (
                                        <div className="col-md-3 mb-2 px-1" key={topic.TypeId}>
                                            <label className="bg-white border shadow-sm me-0 rounded d-flex align-items-center p-[12px]">
                                                <input
                                                    className="text-dark form-check-input w-h-20 cursor-pointer mt-0"
                                                    type="checkbox"
                                                    name={topic.UserType}
                                                    onChange={handleUserTypeChange}
                                                    checked={checkedUserTypes[topic.UserType] || false}
                                                />
                                                <div className="fs-sm ms-1 h-[16px]">{topic.UserType}</div>
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            {/* <div className="position-relative mb-2 mt-3 p-3 border rounded " >
                                <h4 className="d-flex justify-content-start fw-bold mb-0">
                                    {" "}
                                    Age Range{" "}
                                </h4>
                                <div className="d-flex p-2 row">
                                    {ageRange?.map((topic: any) => (
                                        <div className="col-md-3 mb-2 px-1" key={topic.AgeId}>
                                            <label className="bg-white border shadow-sm me-0 rounded d-flex align-items-center p-[12px]">
                                                <input
                                                    className="text-dark form-check-input w-h-20 cursor-pointer mt-0"
                                                    type="checkbox"
                                                    name={topic.AgeRangeDisplayName}
                                                    value={topic.AgeId} 
                                                    onChange={handleAgeRangeChange}
                                                    checked={checkedAgeRanges[topic.AgeId]}
                                                />
                                                <div className="fs-sm ms-1 h-[16px]">{topic.AgeRangeDisplayName}</div>
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div> */}
                        <div className="d-flex justify-content-end mt-5">
                            <button className="btn btn-primary-outline me-2 px-4" type="button" onClick={() => navigate('/contribute')}> Cancel  </button>
                            <button className="btn btn-primary px-4 text-white" type="submit">
                                {selectedTipId == 'New' ? 'Save' : 'Update'}
                            </button>
                        </div>
                    </div>
                </form>

            </div>
        </div>
    )

}